module.exports = __webpack_public_path__ + "img/52.3.TP.794a3041.png";